var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 pb-16"},[(_vm.$route.query.type == 'read')?_c('PolicyRead',{attrs:{"title":"Privacy"}}):_vm._e(),(_vm.$route.query.type == 'write' && _vm.$store.state.lafia_admin.is_logined)?_c('PolicyWrite',{attrs:{"title":"Privacy"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }